__webpack_require__.p = "/local/templates/.default/vue-app-portal/build/";